<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="admin-history">

    <div class="router-header flex flex-wrap items-center mb-6">
      <div class="content-area__heading">
        <h2 class="mb-1">ประวัติการใช้งาน</h2>
      </div>
    </div>

    <div class="vx-card p-6 pt-0 mb-8">
      <div id="div-with-loading" class="vs-con-loading__container">

        <vs-table pagination max-items="10" search :data="userLogs">

          <template slot="thead">
            <vs-th sort-key="log">ประวัติการใช้งาน</vs-th>
            <vs-th sort-key="created_at">วัน</vs-th>
            <vs-th sort-key="created_at">เวลา</vs-th>
            <vs-th sort-key="user_name">ชื่อ</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].log">
                {{ data[indextr].log }}
              </vs-td>

              <vs-td :data="data[indextr].created_at">
                {{ data[indextr].date_format }}
              </vs-td>

              <vs-td :data="data[indextr].created_at">
                {{ data[indextr].created_at | dtFormat('HH:mm:ss') }}
              </vs-td>

              <vs-td :data="data[indextr].user_name">
                {{ data[indextr].user_name }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";

export default {
  components: {
  },
  data:() => ({
    selected:[],
  }),
  created () {
    this.openLoadingInDiv()

    this.$store.dispatch('admin_api/fetchDataListUserLogs', { }).then((res) => {
      this.$vs.loading.close('#div-with-loading > .con-vs-loading')
    })
  },
  computed : {
    userLogs () { return this.$store.state.admin_api.userLogs }
  },
  filters: {
    dtSubtract (dt, duration, unit) {
      return moment.utc(dt).subtract(duration, unit)
    },
    dtFormat (dt, format) {
      return moment.utc(dt).format(format)
    }
  },
  methods: {
    openLoadingInDiv (){
      setTimeout(() => {
        this.$vs.loading({
          container: '#div-with-loading',
          scale: 0.6
        })
      }, 10)
    }
  }
}
</script>

<style lang="scss">
  .con-vs-loading {
    z-index: 9999 !important;
  }
</style>
